import React from 'react';
import * as TableExport from 'tableexport';
import IconButton from '@mui/material/IconButton';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { Grid, Tooltip } from '@mui/material';

const TableToCSVGenerator = props => {
  const { tableRef, fileName = 'export' } = props;

  return (
    <Grid container direction="row" justifyContent="flex-end" alignItems="center">
      <Grid item>
        <Tooltip title="Download CSV">
          <IconButton
            aria-label="delete"
            onClick={() => {
              const exportInstance = TableExport(tableRef.current, {
                formats: ['csv'],
                filename: fileName,
                position: 'top',
                exportButtons: false,
              });

              const tableId = tableRef.current.getAttribute('id');

              if (!tableId) {
                return;
              }

              const exportData = exportInstance.getExportData()[tableId].csv;
              exportInstance.export2file(
                exportData.data,
                exportData.mimeType,
                exportData.filename,
                exportData.fileExtension
              );
            }}
            size="large"
          >
            <CloudDownloadIcon />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default TableToCSVGenerator;
